import { actionTypes, initialState } from "./auth.constant";

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ON_LOGIN_LOADING: {
      return {
        ...state,
        loginLoading: true,
      };
    }
    case actionTypes.ON_LOGIN_SUCCESS: {
      return {
        ...state,
        loginLoading: false,
      };
    }
    case actionTypes.ON_LOGIN_ERR: {
      return {
        ...state,
        loginLoading: false,
        loginError: action.payload,
      };
    }
    case actionTypes.ON_LOGOUT: {
      return {
        ...state,
        loginLoading: false,
      };
    }
    default:
      return { ...state };
  }
};
